import { FormEvent, useState } from 'react'
import { translate } from '../../configuration/localization'
import { platformApi } from '../platform/public'
import { Brand } from '../../ui/foundation/LegacyPrimitives'

export function AuthScreen() {
  const [mode, setMode] = useState<'login' | 'signup'>('login')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [fullName, setFullName] = useState('')
  const [pendingEmail, setPendingEmail] = useState('')
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setMessage('')

    const result = mode === 'login'
      ? await platformApi.auth.signIn(email, password)
      : await platformApi.auth.signUp({ email, password, fullName, emailRedirectTo: window.location.origin })

    setBusy(false)
    if (result.error) {
      setMessage(result.error.message)
      return
    }

    if (mode === 'signup' && !result.data) {
      setPassword('')
      setPendingEmail(email)
    }
  }

  if (pendingEmail) {
    return <main className="auth-page"><section className="auth-card">
      <Brand />
      <p className="eyebrow" style={{ marginTop: '1.7rem' }}>XÁC NHẬN EMAIL</p>
      <h1 style={{ marginTop: 0 }}>Kiểm tra email của bạn</h1>
      <p className="muted">Chúng tôi đã gửi link xác nhận đến <strong>{pendingEmail}</strong>.</p>
      <div className="notice" role="status" aria-live="polite">Mở email và bấm link xác nhận. Sau đó bạn sẽ được đưa trở lại Pactlane để đăng nhập hoặc tiếp tục vào workspace.</div>
      <div className="stack" style={{ marginTop: '1rem' }}>
        <button className="primary" onClick={() => { setMode('login'); setEmail(pendingEmail); setPendingEmail(''); setMessage('') }}>Tôi đã xác nhận — đăng nhập</button>
        <button className="link-button" onClick={() => { setPendingEmail(''); setMode('signup'); setMessage('') }}>Dùng email khác</button>
      </div>
    </section></main>
  }

  return <main className="auth-page"><section className="auth-card">
    <Brand />
    <h1>{mode === 'login' ? translate('auth.login') : translate('auth.signup')}</h1>
    <p className="muted">Agency Admin, Operator và Client Viewer đăng nhập bằng email công việc. Creator truy cập nhiệm vụ bằng signed link riêng.</p>
    <form className="stack" onSubmit={submit}>
      {mode === 'signup' && <label>Họ tên<input autoComplete="name" required value={fullName} onChange={(e) => setFullName(e.target.value)} /></label>}
      <label>{translate('auth.email')}<input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></label>
      <label>{translate('auth.password')}<input type="password" autoComplete={mode === 'login' ? 'current-password' : 'new-password'} minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} /></label>
      {message && <div className="notice error">{message}</div>}
      <button className="primary" disabled={busy}>{busy ? 'Đang xử lý…' : mode === 'login' ? translate('auth.login') : translate('auth.signup')}</button>
    </form>
    <button className="link-button" onClick={() => { setMode(mode === 'login' ? 'signup' : 'login'); setMessage('') }}>
      {mode === 'login' ? 'Chưa có tài khoản? Tạo mới' : 'Đã có tài khoản? Đăng nhập'}
    </button>
  </section></main>
}
